module.exports = __webpack_public_path__ + "static/media/v.ec35705a.webm";